module.exports = __webpack_public_path__ + "media/images/training-success-evaluation-score-modal-3112c3aee6eafa46760184cf5c385a15.svg";